import script from "./ScheduleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleManagement.vue?vue&type=style&index=0&id=c4e766e0&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4e766e0"]])

export default __exports__